export default {

	async modal_edit (event_id, aee_id = null, event_type = null) {

		const aee = (aee_id == null) ? Anvil.page.aee : await Anvil.models.c_order.AEE.fetch(aee_id)
		const aee_event = await Anvil.models.c_order.AEEEvent.fetch(event_id)

		// If this is a new event, set the aee_id
		if (aee_event.id === null) {
			aee_event.aee_id = aee.id
			aee_event.event = event_type
		}

		await Anvil.modal('/c_order/aee_event/modal_edit', { aee: aee, aee_event })
	},

	async action_save (aee_event) {

		// Tell the record to commit
		await aee_event.record.commit()

		Anvil.toast.success('Elmentve', 'Az esemény mentése sikeres')
		Anvil.page.modal.close()

		// Refresh list
		if ('refresh' in Anvil.page) {
			await Anvil.page.refresh()
		}

		// Focus on aee_event
		let grid = Anvil.models.components.Grid.find('#aee_event_grid')
		if (grid) {
			grid.select(grid.list.getById(aee_event.id), true)
		}

		return true
	},

	async action_delete (id, confirm = false) {

		// Megerősítés kérése
		if (!confirm) {
			Anvil.confirm({
				title: 'Törlés megerősítése',
				message: '<p>Valóban törölni szeretné a kijelölt eseményt a nyilvántartásból?</p>',
				btn_ok: '<i class="fas fa-trash me-2"></i>Törlés',
				btn_ok_class: 'danger',
				btn_cancel: '<i class="fas fa-times me-2"></i>Mégsem',
				onclose: (confirmed) => {
					if (confirmed) {
						Anvil.exec('c_order/aee_event/action_delete', id, true)
					}
				}
			})
			return
		}

		await Anvil.models.c_order.AEEEvent.delete(id)

		Anvil.toast.success('Törölve', 'Az esemény nyilvántartásból való törlése sikeres')

		// Refresh list
		await Anvil.controllers.c_order.aee.action_refresh_log()
	},
}